import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom'
import {Grid} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {Map} from 'immutable';

import {Wrapper} from 'system/wrapper';
import {DetailList} from './components';
import {Divider} from 'components/common';
import Breadcrumbs from '../../breadcrumbs';
import Spinner from 'spinner';
import CardsInstitutions from 'system/cards-institutions';

import {loadServiceDetail} from 'redux/actions/portal/services';
import service from 'images/general/poslugi.svg';
import hospital from 'images/general/hospital.svg';

const mapStateToProps = (state) => ({
  detail: state.services.get('serviceDetail'),
  isFetching: state.services.get('servicesIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (id) => dispatch(loadServiceDetail(id))
});

class ServiceDetail extends Component {

  multilineStyle = {
    whiteSpace: 'pre-wrap',
    lineHeight: '1.3'
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.id)
  }
  render() {
    const item = this.props.detail;

    if (this.props.detail === undefined) {
      return null;
    }

    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/services">Послуги</Link></li>
          <li><Link to={`/services/detail/${encodeURIComponent(item.get('id'))}`}>Послуга {item.get('code')}</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>
              <img src={service} alt="hospital" /><br/>
              Послуга
            </h2>
            {this.props.isFetching ? (
              <Spinner />
            ):(
              <DetailList>
                <li><span>Код: </span>{item.get('code')}</li>
                <li style={this.multilineStyle}><span>Назва: </span>{item.get('title')}</li>
                <li style={this.multilineStyle}><span>Опис послуги: </span>{item.get('description') || "Інформація відсутня"}</li>
                <li style={this.multilineStyle}><span>Підготовка до отримання послуги: </span>{item.get('instruction') || 'Інформація відсутня'}</li>
                <li style={this.multilineStyle}><span>Додаткові відомості та особливості: </span>{item.get('additional_info') || "Інформація відсутня"}</li>
              </DetailList>
            )}
            <Divider>
              <h2>
                <img src={hospital} alt="hospital" /><br/>
                Медичні заклади, які надають дану послугу
              </h2>
            </Divider>
              <CardsInstitutions >
                  {this.props.detail.get('institution_service_data').map((item, i) => (
                      <li key={item.get('institution_data').get('id')}  style={
                        {backgroundImage: `url(${item.get('photo') ? item.get('photo') : null})`, backgroundSize: "cover ", backgroundRepeat: "no-repeat", backgroundPosition: "center"}}
                      >
                          {item.get('photo') ? (
                              null
                          ):(
                              <img src={hospital} alt="hospital"/>
                          )}

                          <Link to={`/institutions/detail/${item.get('institution_data').get('id')}/service/${item.get('id')}`}>
                              <div>
                                  <h3>{item.get('institution_data').get('full_title')}</h3>
                              </div>
                          </Link>
                      </li>
                  ))}
              </CardsInstitutions>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}
ServiceDetail.propTypes = {
  detail: PropTypes.instanceOf(Map),
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetail);



// WEBPACK FOOTER //
// ./src/system/main/services/detail.js